













import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class VVideoButton extends Vue {
  @Prop({ required: true }) readonly url!: string | null;
}
